module.exports = __webpack_public_path__ + "media/military/military_ocs_btn_hover-5327ee02.png";